import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'
import { NAWSurvey } from '../../../../../types/NAW/Survey'
import ResultOutput from '../../Elements/ResultOutput'
import HeadlineSplit from '../HeadlineSplit'
import { getErsparnisPercentage, getJaehrlicheErsparnis, getNeueBueroflaeche } from './calculation'
import { formatNumber } from '../../../../../utility'
import Button from '../../../../UI/Button/Button'
import { useEffect, useState } from 'react'
import { Update } from '../../../../hooks/NAW/useNAWSurveyAnswer/useNAWSurveyAnswer'
import Config from './Config'

type Props = {
  survey: NAWSurvey
  finalize: () => void
  update: Update
}

const Result: React.FC<Props> = ({ survey, update, finalize }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const [showHint, setShowHint] = useState(false)

  useEffect(() => {
    setShowHint(getErsparnisPercentage(survey) === 0 || getJaehrlicheErsparnis(survey) === 0)
  }, [showHint, survey])

  return (
    <div className="flex flex-col gap-10 relative h-full">
      <HeadlineSplit suffix={t.naw.survey.answer.summary.result.suffix} subline={t.naw.survey.answer.summary.result.subline} />
      <div className="md:mt-[60px] h-full flex flex-col">
        <div>
          <ResultOutput
            label={t.naw.survey.answer.summary.result.neueFlaeche}
            value={`${formatNumber(getNeueBueroflaeche(survey))}${t.generic.squareMeterSuffix}`}
            // description={t.naw.survey.answer.summary.result.neueFlaecheDescription}
          />
          <ResultOutput
            label={t.naw.survey.answer.summary.result.ersparnisFlaeche}
            value={`${getErsparnisPercentage(survey)}${t.generic.percentageSuffix}`}
            // description={t.naw.survey.answer.summary.result.ersparnisFlaecheDescription}
          />
          <ResultOutput
            label={t.naw.survey.answer.summary.result.jaehrlicheErsparnis}
            value={`${formatNumber(getJaehrlicheErsparnis(survey))}${t.generic.euroSuffix}`}
            // description={t.naw.survey.answer.summary.result.jaehrlicheErsparnisDescription}
            isLast
          />
        </div>
        {showHint && (
          <div className="mt-5">
            {/* <div>
              {t.naw.survey.answer.summary.result.noReduction.text.map((t, i) => (
                <div className="text-cyan text-sm" key={i}>
                  {t}
                </div>
              ))}
            </div>
            <ul className="ml-0 list-none">
              {t.naw.survey.answer.summary.result.noReduction.list.map((t, i) => (
                <li key={i}>
                  <span className="text-cyan">{'>'}</span>
                  {` ${t}`}
                </li>
              ))}
            </ul> */}
            <div>
              <span>{t.naw.survey.answer.summary.result.noReductionSplitted.preHomeofficeTage}</span>
              <span className="text-cyan">{t.naw.survey.answer.summary.result.noReductionSplitted.homeofficeTage}</span>
              <span>{t.naw.survey.answer.summary.result.noReductionSplitted.preDesksharingQuote}</span>
              <span className="text-cyan">{t.naw.survey.answer.summary.result.noReductionSplitted.desksharingQuote}</span>
              <span>{t.naw.survey.answer.summary.result.noReductionSplitted.preDigitalisierung}</span>
              <span className="text-cyan">{t.naw.survey.answer.summary.result.noReductionSplitted.digitalisierung}</span>
              <span>{t.naw.survey.answer.summary.result.noReductionSplitted.postDigitalisierung}</span>
            </div>
          </div>
        )}
        <div className="flex-1 md:hidden mt-3">
          <Config survey={survey} update={update} />
        </div>
        <div className="h-full flex items-start justify-center mt-3 md:mt-10">
          <Button onClick={finalize} text={t.naw.survey.answer.navigation.submit} className="text-lg" />
        </div>
      </div>
    </div>
  )
}

export default Result
